import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {StaticPage} from '../../models/cms/static-page';
import {Observable, Subscriber} from 'rxjs';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class StaticPageService extends AbstractModelService<StaticPage> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/static-page', StaticPage);
  }

  preview(staticPage: StaticPage, country: string): Observable<any> {
    return new Observable<void>((subscriber: Subscriber<any>): void => {
      this.apiClient.post(this.routePath + '/' + staticPage.id + '/preview', {}, {
        country,
        html: staticPage.htmlContent
      }).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
